import { render, staticRenderFns } from "./DistributorsTable.vue?vue&type=template&id=24a251cf&scoped=true&"
import script from "./DistributorsTable.vue?vue&type=script&lang=js&"
export * from "./DistributorsTable.vue?vue&type=script&lang=js&"
import style0 from "./DistributorsTable.vue?vue&type=style&index=0&id=24a251cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a251cf",
  null
  
)

export default component.exports